type DateDividerProps = {
  label: string;
};

export function DateDivider({ label }: DateDividerProps) {
  return (
    <div className="flex items-center gap-3 my-6">
      <div className="flex-1 border-t border-border/20" />
      <span className="text-[11px] text-muted-foreground/50 font-medium select-none">
        {label}
      </span>
      <div className="flex-1 border-t border-border/20" />
    </div>
  );
}
